import React, { useEffect, useState } from "react";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import backarrow from "../../Assets/svg/backarrow.svg";
import reddelete from "../../Assets/svg/reddelete.svg";
import close from "../../Assets/svg/close1.svg";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SearchWithAPI from "../common/searchbox/searchbox.js";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import { apiCall } from "../../services/api-service.js";

const ApprovalAdd = ({ children }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {};
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [selectedRegionOptions, setSelectedRegionOptions] = useState([]);
  const [selectedLocationOptions, setSelectedLocationOptions] = useState([]);
  const [selectedProjectOptions, setSelectedProjectOptions] = useState([]);
  const [selectedComponentOptions, setSelectedComponentOptions] = useState([]);

  const [removedApprovalLines, setRemovedApprovalLines] = useState([]);
  const [approvalName, setApprovalName] = useState("");


  const [validations, setValidations] = useState({
    name: "",
    regions: "",
    locations: "",
    projects: "",
    components: "",
    approval_lines: "",
  });

  useEffect(() => {
    if (id != null && id !== undefined) {
      approvalConfigEdit(id);
    }
  }, []);
  const [filters, setFilters] = useState([]);

  const addFilter = () => {
    setFilters([
      ...filters,
      {
        id: "",
        role: null,
        user: { value: "", label: "Select" },
      },
    ]);
  };

  const removeFilter = (index) => {
    if (filters[index].id != null && filters[index].id !== "") {
      setRemovedApprovalLines([...removedApprovalLines, filters[index].id]);
    }
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleRoleTypeDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].role = selectedOptions;
      setFilters(tempList);
    }
  };
  const handleUserDropdownChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...filters];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].user = selectedOptions;
      setFilters(tempList);
    }
  };

  const [groupedError, setGroupedError] = useState({});

  const handleApiError = (errorData) => {
    const groupedErrorTemp = {};
    const validationTemp = {
      name: "",
      regions: "",
      locations: "",
      projects: "",
      components: "",
      approval_lines: "",
    };
    if (errorData?.error) {
      Object.entries(errorData.error).forEach(([key, value]) => {
        const match = key.match(/^approval_lines\.(\d+)\.(.+)$/);
        if (match) {
          const idx = match[1];
          const field = match[2];
          if (!groupedErrorTemp[idx]) groupedErrorTemp[idx] = {};
          groupedErrorTemp[idx][field] = value;
        }
        if (key in validationTemp) {
          validationTemp[key] = Array.isArray(value) && value.length > 0 ? value[0] : "";
        }
      });
    }
    setGroupedError(groupedErrorTemp);
    setValidations(validationTemp);
  };

  const approvalConfigSubmit = async () => {
    const approvalLines = filters.map((item, index) => ({
      seq_no: index + 1,
      role_id: item.role?.value ?? "",
      emp_id: item.user?.value ?? "",
    }));

    setValidations({
      name: "",
      regions: "",
      locations: "",
      projects: "",
      components: "",
      approval_lines: "",
    });

    const requestBody = {
      name: approvalName,
      regions: selectedRegionOptions.filter((i) => i.value !== "").map((i) => i.value),
      locations: selectedLocationOptions.filter((i) => i.value !== "").map((i) => i.value),
      projects: selectedProjectOptions.filter((i) => i.value !== "").map((i) => i.value),
      components: selectedComponentOptions.filter((i) => i.value !== "").map((i) => i.value),
      approval_lines: approvalLines,
      removed_lines: removedApprovalLines,
    };

    const isNew = id === null || id === undefined || id === -1;
    const response = isNew
      ? await apiCall("post", "approval", requestBody)
      : await apiCall("put", `approval/${id}`, requestBody);

    if (response?.data?.success === true) {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(true);
      handleSnackbarShow();
      navigate(-1);
    } else {
      setSnackbarMessage(response?.data?.message ?? "");
      setSnackbarStatus(false);
      handleSnackbarShow();
      handleApiError(response?.data);
    }
  };

  const approvalConfigEdit = async (id) => {
    const response = await apiCall("get", `approval/${id}`);
    if (response?.data?.success === true) {
      const approval = response.data.aprroval;
      setApprovalName(approval.name);
      setSelectedRegionOptions(approval.regions ?? []);
      setSelectedLocationOptions(approval.locations ?? []);
      setSelectedProjectOptions(approval.projects ?? []);
      setSelectedComponentOptions(approval.components ?? []);
      setFilters(
        approval.lines.map((item) => ({
          id: item.id,
          seq_no: item.seq_no,
          role:
            item.role_id && item.role_id !== 0 && item.role_id !== "0"
              ? { value: item.role_id, label: item.role_name ?? "Select" }
              : null,
          user: { value: item.emp_id ?? "", label: item.emp_name ?? "Select" },
        }))
      );
    }
  };
  const getErrorMsg = (index, field) => {
    if (field === "emp_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].emp_id != null) {
          return (
            groupedError[index].emp_id[0]?.replace(
              `approval_lines.${index}.emp_id`,
              "user"
            ) ?? ""
          );
        }
      }
    }
    if (field === "role_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].role_id != null) {
          return (
            groupedError[index].role_id[0]?.replace(
              `approval_lines.${index}.role_id`,
              "role"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };
  const handleRegionDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedRegionOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedRegionOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedRegionOptions(updatedOptions);
    } else {
      setSelectedRegionOptions([...selectedRegionOptions, selectedOptions]);
    }
  };

  const handleLocationDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedLocationOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedLocationOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedLocationOptions(updatedOptions);
    } else {
      setSelectedLocationOptions([...selectedLocationOptions, selectedOptions]);
    }
  };

  const handleProjectDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedProjectOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedProjectOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedProjectOptions(updatedOptions);
    } else {
      setSelectedProjectOptions([...selectedProjectOptions, selectedOptions]);
    }
  };

  const handleComponentDropdownChange = (selectedOptions) => {
    const targetVal = String(selectedOptions?.value ?? selectedOptions?.id ?? "");
    if (!targetVal) return;
    const index = selectedComponentOptions.findIndex(
      (option) => String(option?.value ?? option?.id ?? "") === targetVal
    );
    if (index > -1) {
      const updatedOptions = selectedComponentOptions.filter(
        (option) => String(option?.value ?? option?.id ?? "") !== targetVal
      );
      setSelectedComponentOptions(updatedOptions);
    } else {
      setSelectedComponentOptions([
        ...selectedComponentOptions,
        selectedOptions,
      ]);
    }
  };

  return (
    <Container
      fluid
      style={{ width: "100%", padding: "0px", fontFamily: "Satoshi" }}
    >
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div className="maincontent3">
              <div
                className="px-3 d-flex flex-column"
                style={{ backgroundColor: "#F3F6F9", gap: "24px" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "12px" }}
                  >
                    <Link to="/approval/list">
                      {" "}
                      <div>
                        <img src={backarrow} alt="" />
                      </div>
                    </Link>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "16px",
                        color: "#212129",
                      }}
                    >
                      {id != null && id !== "" ? "Edit" : "Add"} Approval
                    </div>
                  </div>

                  <div
                    className="d-flex align-items-center"
                    style={{ gap: "12px" }}
                  >
                    <Link to="/approval/list">
                      <button
                        className="px-4 py-2"
                        style={{
                          border: "0.6px solid #E5E5E5",
                          borderRadius: "100px",
                          backgroundColor: "#FFFFFF",
                          color: "#21272C",
                          fontWeight: "700",
                          fontSize: "14px",
                        }}
                      >
                        Cancel
                      </button>
                    </Link>

                    <button
                      onClick={() => approvalConfigSubmit()}
                      className="px-4 py-2"
                      style={{
                        border: "0.6px solid #E5E5E5",
                        borderRadius: "100px",
                        backgroundColor: "#6929E2",
                        color: "#FFFFFF",
                        fontWeight: "700",
                        fontSize: "14px",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>

                <div
                  className="px-4 py-4 mb-3"
                  style={{ borderRadius: "16px", backgroundColor: "#FFFFFF" }}
                >
                  <div
                    className="d-flex flex-column mb-4"
                    style={{ gap: "12px" }}
                  >
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "20px",
                        color: "#212129",
                      }}
                    >
                      {id != null && id !== "" ? "Edit" : "Add"} Approval
                    </div>

                    <div
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        color: "#8790A1",
                      }}
                    >
                      Enter below details to create new approval configure
                    </div>
                  </div>

                  <div className="d-flex flex-column" style={{ gap: "24px" }}>
                    <Row className="py-1" style={{ width: "100%" }}>
                      <Col sm={12} md={6} lg={6} xl={6} className="mt-2">
                        <div
                          className="pb-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            color: "#212129",
                          }}
                        >
                          Approval name<span style={{ color: "red" }}> *</span>
                        </div>
                        <div>
                          <input
                            type="text"
                            value={approvalName}
                            onChange={(event) => {
                              setApprovalName(event.target.value);
                            }}
                            placeholder="Enter here"
                            style={{
                              width: "100%",
                              borderRadius: "10px",
                              border: "0.8px solid #E5E5E5",
                              backgroundColor: "#FFFFFF",
                              fontWeight: "500",
                              fontSize: "14px",
                              color: "#21272C",
                            }}
                            className="px-3 py-2"
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.name}
                          </span>
                        </div>
                      </Col>
                    </Row>
                    <Row style={{ width: "100%" }}>
                      <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                        <div
                          className="pb-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            color: "#212129",
                          }}
                        >
                          Region<span style={{ color: "red" }}> *</span>
                        </div>
                        <div>
                          <MultiSelectDropDown
                            onDropdownChange={handleRegionDropdownChange}
                            apiUrl={adminUrl + `region/autocomplete`}
                            placeholder={"Region"}
                            selectedOption={selectedRegionOptions}
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.regions}
                          </span>
                        </div>
                      </Col>
                      <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                        <div
                          className="pb-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            color: "#212129",
                          }}
                        >
                          Location<span style={{ color: "red" }}> *</span>
                        </div>
                        <div>
                          <MultiSelectDropDown
                            onDropdownChange={handleLocationDropdownChange}
                            apiUrl={adminUrl + `get_location`}
                            placeholder={"Location"}
                            selectedOption={selectedLocationOptions}
                            params={
                              selectedRegionOptions.filter((r) => r.value !== "").length > 0
                                ? {
                                    region_id: selectedRegionOptions
                                      .filter((r) => r.value !== "")
                                      .map((r) => r.value)
                                      .join(","),
                                  }
                                : {}
                            }
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.locations}
                          </span>
                        </div>
                      </Col>

                      <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                        <div
                          className="pb-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            color: "#212129",
                          }}
                        >
                          Project<span style={{ color: "red" }}> *</span>
                        </div>
                        <div>
                          <MultiSelectDropDown
                            onDropdownChange={handleProjectDropdownChange}
                            apiUrl={apiUrl + `get_project`}
                            placeholder={"Project"}
                            selectedOption={selectedProjectOptions}
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.projects}
                          </span>
                        </div>
                      </Col>

                      <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                        <div
                          className="pb-2"
                          style={{
                            fontWeight: "500",
                            fontSize: "13px",
                            color: "#212129",
                          }}
                        >
                          Component<span style={{ color: "red" }}> *</span>
                        </div>
                        <div>
                          <MultiSelectDropDown
                            onDropdownChange={handleComponentDropdownChange}
                            apiUrl={apiUrl + `get_component`}
                            placeholder={"Component"}
                            selectedOption={selectedComponentOptions}
                          />
                          <span
                            style={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "#FF4444",
                            }}
                          >
                            {validations.components}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>

                <div
                  className="px-4 py-4 d-flex flex-column"
                  style={{
                    borderRadius: "16px",
                    gap: "10px",
                    backgroundColor: "#FFFFFF",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                      color: "#212129",
                    }}
                    className="mb-2"
                  >
                    Filter
                  </div>
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: 400,
                      color: "#FF4444",
                    }}
                  >
                    {validations.approval_lines}
                  </span>
                  <div
                    className="px-3 py-3"
                    style={{ backgroundColor: "#F5F6F7", borderRadius: "16px" }}
                  >
                    {filters.map((filter, fIndex) => {
                      const hasRole = Boolean(
                        filter.role &&
                          filter.role.value &&
                          filter.role.value !== "" &&
                          filter.role.value !== 0 &&
                          filter.role.value !== "0"
                      );
                      return (
                        <div
                          key={"line" + (filter.id || fIndex)}
                          className="my-2 px-3 py-2"
                          style={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "16px",
                          }}
                        >
                          <div className="d-flex align-items-center justify-content-start">
                            <Row style={{ width: "100%" }}>
                              <Col sm={12} md={6} lg={4} xl={4} className="mt-2">
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                    marginBottom: "8px",
                                  }}
                                ></p>
                                <div>Approval {fIndex + 1}</div>
                              </Col>

                              {hasRole && (
                                <Col sm={12} md={6} lg={3} xl={3} className="mt-2">
                                  <p
                                    style={{
                                      fontFamily: "Satoshi",
                                      fontSize: "13px",
                                      fontWeight: "500",
                                      lineHeight: "17.55px",
                                      color: "#212129",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    Role
                                  </p>
                                  <SearchWithAPI
                                    searchId={fIndex}
                                    onChangeIndex={{ parentIndex: fIndex }}
                                    onDropdownChange={handleRoleTypeDropdownChange}
                                    apiUrl={adminUrl + `get_role`}
                                    placeholder={"Role"}
                                    selectedValue={
                                      filter.role != null ? filter.role.label : ""
                                    }
                                    selectedOption={filter.role}
                                  />
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      color: "#FF4444",
                                    }}
                                  >
                                    {getErrorMsg(fIndex, "role_id")}
                                  </span>
                                </Col>
                              )}
                              <Col
                                sm={12}
                                md={6}
                                lg={hasRole ? 3 : 6}
                                xl={hasRole ? 3 : 6}
                                className="mt-2"
                              >
                                <p
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    lineHeight: "17.55px",
                                    color: "#212129",
                                    marginBottom: "8px",
                                  }}
                                >
                                  User
                                </p>
                                <SearchWithAPI
                                  searchId={fIndex}
                                  onChangeIndex={{ parentIndex: fIndex }}
                                  onDropdownChange={handleUserDropdownChange}
                                  apiUrl={apiUrl + `get_employee`}
                                  placeholder={"User"}
                                  selectedValue={
                                    filter.user != null ? filter.user.label : ""
                                  }
                                  selectedOption={filter.user}
                                />
                                <span
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "#FF4444",
                                  }}
                                >
                                  {getErrorMsg(fIndex, "emp_id")}
                                </span>
                              </Col>
                            </Row>
                          <div
                            style={{
                              width: "70px",
                              display: "flex",
                              alignItems: "end",
                              justifyContent: "center",
                            }}
                            className="mt-2"
                          >
                            <div
                              onClick={() => {
                                removeFilter(fIndex);
                              }}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "44px",
                                height: "44px",
                                borderRadius: "100px",
                                background: "#F6F7F8",
                              }}
                            >
                              {" "}
                              <img
                                src={reddelete}
                                style={{ width: "40px", height: "40px" }}
                                alt="Delete"
                              />{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    );})}

                    <button
                      className="px-2 py-2"
                      onClick={addFilter}
                      style={{
                        borderRadius: "16px",
                        fontWeight: "700",
                        fontSize: "13.5px",
                        color: "#6929E2",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      + Add filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                                                <strong className="mr-auto">Snackbar Title</strong>
                                                              </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default ApprovalAdd;
